import './includes/sentry';

import.meta.glob([
    '../assets/logos/favicon/favicon.ico',
    '../assets/logos/favicon/apple-touch-icon.avif',
]);

import {
    browserSupportsWebAuthn,
    startAuthentication,
    startRegistration,
} from '@simplewebauthn/browser'

window.browserSupportsWebAuthn = browserSupportsWebAuthn;
window.startAuthentication = startAuthentication;
window.startRegistration = startRegistration;
